import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { ChangeList } from "../../components/change-list";

/** Every recorded change for this client, newest first, with its exact diff. */
export function HistoryTab({ clientId }: { clientId: number }) {
  const changes = useQuery({
    queryKey: ["b2b", "changes", clientId],
    queryFn: () => api.b2b.changes({ clientId, limit: 100 }),
  });

  return (
    <div className="rounded-xl border bg-card">
      <div className="border-b px-6 py-4">
        <h2 className="font-semibold">History</h2>
        <p className="text-sm text-muted-foreground">
          Every change to this client, who made it, and exactly what moved
        </p>
      </div>
      <div className="p-2">
        <ChangeList
          changes={changes.data?.items ?? []}
          loading={changes.isLoading}
          emptyMessage="Nothing has changed since this tool started recording."
        />
      </div>
    </div>
  );
}
